<template>
  <div class="home">
    <img src="../assets/SIP_logo.png" srcset="../assets/SIP_logo.png 1x, ../assets/SIP_logo@2x.png 2x, ../assets/SIP_logo@3x.png" alt="SIP Logo">
    <p>How well can you spot safety hazards? Let’s put your safety skills to the test!</p>
    <Button text="Continue" @click.native="goToInstructions" />
  </div>
</template>

<script>
import Button from '@/components/Button.vue'

export default {
  name: 'home',
  components: {
    Button
  },
  methods: {
    goToInstructions() {
      this.$router.push('/instructions')
    }
  },
  mounted() {
    window.scrollTo(0, 1)
  }
}
</script>

<style lang="scss" scoped>
.home {
  background: none;
  left: 50%;
  max-width: 325px;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 90%;

  p {
    font-size: 24px;
    font-weight: bold;
    margin: 40px auto;
    width: 100%;
  }
}

@media (orientation: landscape) {
  .home {
    max-width: 100%;

    p {
      font-size: 21px;
      margin: 15px auto 15px;
    }
  }
}
</style>